import { signupCookie } from '@/utils/cookies/signupCookie';
import styled from './index.module.scss';
import gtm from '@/utils/gtm';

export default function JPBannerCTA({ title }: { title: string }) {
    function handleClick() {
        gtm.push({
            event: 'uaEvent',
            event_name: 'ecocredits_button',
            type: 'register',
            button_name: '新規会員登録',
            list_name: title,
        });
        signupCookie?.({
            sector_name: '新規会員登録',
            entry_position: 1,
        });
        window.open('https://www.ecoflow.com/jp/register?redirect=https%3A%2F%2Fwww.ecoflow.com%2Fjp%2Fmembers-day');
    }
    return (
        <div className={styled.JoinJpLead}>
            <div className="lead_btn" onClick={handleClick}>
                {'新規会員登録 >>'}
            </div>
        </div>
    );
}
